module.exports = __webpack_public_path__ + "static/media/download.670f944f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download.svg
// module id = 357
// module chunks = 1